"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.money = exports.timeFull = exports.time = exports.cellphone = exports.phone = exports.dateFull = exports.date = exports.creditCardDate = exports.creditCard = exports.cpf = exports.cnpj = exports.cep = exports.choseMask = exports.masks = void 0;
exports.masks = {
    'cep': {
        'placeholder': '00000-000',
        'length': 9
    },
    'cnpj': {
        'placeholder': '00.000.000/0000-00',
        'length': 18
    },
    'cpf': {
        'placeholder': '000.000.000-00',
        'length': 14
    },
    'credit-card': {
        'placeholder': '0000-0000-0000-0000',
        'length': 19
    },
    'credit-card-date': {
        'placeholder': '00/00',
        'length': 5
    },
    'date': {
        'placeholder': '00/00/0000',
        'length': 10
    },
    'date-full': {
        'placeholder': '00/00/0000 00:00:00',
        'length': 19
    },
    'phone': {
        'placeholder': '(00) 0000-0000',
        'length': 14
    },
    'cellphone': {
        'placeholder': '(00) 00000-0000',
        'length': 15
    },
    'time': {
        'placeholder': '00:00',
        'length': 5
    },
    'time-full': {
        'placeholder': '00:00:00',
        'length': 8
    },
    'money': {
        'placeholder': '000.000.000.000.000,00',
        'length': 22
    },
    'money-real': {
        'placeholder': '000.000.000.000.000,00',
        'length': 25
    },
    'money-dolar': {
        'placeholder': '000.000.000.000.000,00',
        'length': 24
    },
    'money-euro': {
        'placeholder': '000.000.000.000.000,00',
        'length': 24
    },
};
function choseMask(mask, e) {
    switch (mask) {
        case "cep":
            return cep(e);
        case "cnpj":
            return cnpj(e);
        case "cpf":
            return cpf(e);
        case "credit-card":
            return creditCard(e);
        case "credit-card-date":
            return creditCardDate(e);
        case "date":
            return date(e);
        case "date-full":
            return dateFull(e);
        case "phone":
            return phone(e);
        case "cellphone":
            return cellphone(e);
        case "time":
            return time(e);
        case "time-full":
            return timeFull(e);
        case "money":
        case "money-real":
        case "money-dolar":
        case "money-euro":
            return money(e, mask);
        default:
            return cpf(e);
    }
}
exports.choseMask = choseMask;
function cep(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{3})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.cep = cep;
function cnpj(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.cnpj = cnpj;
function cpf(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.cpf = cpf;
function creditCard(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.creditCard = creditCard;
function creditCardDate(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '$1/$2')
        .replace(/(\/\d{2})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.creditCardDate = creditCardDate;
function date(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\/\d{4})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.date = date;
function dateFull(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '$1/$2')
        .replace(/(\/\d{2})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1 $2')
        .replace(/(\s\d{2})(\d)/, '$1:$2')
        .replace(/(:\d{2})(\d)/, '$1:$2')
        .replace(/(:\d{2})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.dateFull = dateFull;
function phone(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '($1) $2')
        .replace(/(\s\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.phone = phone;
function cellphone(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '($1) $2')
        .replace(/(\s\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.cellphone = cellphone;
function time(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '$1:$2')
        .replace(/(\/\d{2})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.time = time;
function timeFull(e) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, '')
        .replace(/(^\d{2})(\d)/, '$1:$2')
        .replace(/(\d{2})(\d)/, '$1:$2')
        .replace(/(:\d{2})\d+?$/, '$1');
    e.currentTarget.value = value;
    return e;
}
exports.timeFull = timeFull;
function money(e, mask) {
    var value = e.currentTarget.value;
    value = value.replace(/\D/g, "");
    if (mask === 'money-real') {
        value = "R$ " + value;
    }
    else if (mask === 'money-dolar') {
        value = "$ " + value;
    }
    else if (mask === 'money-euro') {
        value = "€ " + value;
    }
    value = value.replace(/(\d)(\d{2})$/, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
    e.currentTarget.value = value;
    return e;
}
exports.money = money;
